module.exports = __webpack_public_path__ + "img/markingAssignments1.add743e4.png";